import { render, staticRenderFns } from "./log-notify.vue?vue&type=template&id=fc37279c&scoped=true"
import script from "./log-notify.vue?vue&type=script&lang=js"
export * from "./log-notify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc37279c",
  null
  
)

export default component.exports